import React from 'react';
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import styles from './NotificationBanner.module.css'; interface NotificationBannerProps {
    haveOvertime?: boolean;
    haveActiveAfm?: boolean;
    /** Готовый текст про ревизии на сегодня; пустая строка — показывать нечего */
    todayAuditText?: string;
    haveCharterCapitalShortage?: boolean;
    /** Клик по недостаче уставного капитала — открыть подробности */
    onCharterCapitalClick?: () => void;
}

export const NotificationBanner: React.FC<NotificationBannerProps> = ({
    haveOvertime = false,
    haveActiveAfm = false,
    todayAuditText = "",
    haveCharterCapitalShortage = false,
    onCharterCapitalClick,
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const renderContent = () => {
        const messages = [];

        if (haveOvertime) {
            messages.push(
                <span key="overtime" className={styles.messageItem}>
                    <span className={styles.icon}>⚠️</span>
                    <span className={styles.text}>Проведите заведенные заявки</span>
                    <span className={styles.icon}>⚠️</span>
                </span>
            );
        }

        if (haveActiveAfm) {
            messages.push(
                <span key="afm" className={styles.messageItem}>
                    <span className={styles.icon}>⚠️</span>
                    <span className={styles.text}>
                        {isMobile ? 'Неотправленные анкеты АФМ' : 'Имеются неотправленные анкеты АФМ'}
                    </span>
                    <span className={styles.icon}>⚠️</span>
                </span>
            );
        }

        if (todayAuditText) {
            messages.push(
                <span key="audit" className={styles.messageItem}>
                    <span className={styles.icon}>⚠️</span>
                    <span className={styles.text}>{todayAuditText}</span>
                    <span className={styles.icon}>⚠️</span>
                </span>
            );
        }

        if (haveCharterCapitalShortage) {
            messages.push(
                <span
                    key="charterCapital"
                    className={`${styles.messageItem} ${styles.clickable}`}
                    role="button"
                    onClick={onCharterCapitalClick}
                >
                    <span className={styles.icon}>⚠️</span>
                    <span className={styles.text}>
                        {isMobile ? 'Нарушение УК' : 'Нарушение уставного капитала'}
                    </span>
                    <span className={styles.icon}>⚠️</span>
                </span>
            );
        }

        return messages.length > 0 ? messages : null;
    };

    // Если нет уведомлений, возвращаем пустой div для сохранения структуры flex
    if (!haveOvertime && !haveActiveAfm && !todayAuditText && !haveCharterCapitalShortage) {
        return isMobile ? null : <div style={{ display: 'none' }} />;
    }

    if (isMobile) {
        return (
            <div className={styles.mobileContainer}>
                <span className={styles.mobileContent}>
                    {renderContent()}
                </span>
            </div>
        );
    }

    return (
        <Typography
            variant="h6"
            color="inherit"
            className={styles.desktopContainer}
            component="div"
        >
            <span className={styles.desktopContent}>
                {renderContent()}
            </span>
        </Typography>
    );
};

export default NotificationBanner;
